import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { FullstoryIdentity } from '@bannerflow/fullstory';
import { Observable, map, switchMap } from 'rxjs';
import {
  ICurrentUser,
  IUserDefaults,
} from 'src/app/shared/models/account.model';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root',
})
export class AccountAccessService {
  private http = inject(HttpClient);
  private baseUrl = ConfigService.config.ACCOUNT_ACCESS_URL;

  /**
   * Two calls because this app holds neither slug: it has no account picker and
   * uploads carry no account, so the user's default account and brand are its
   * context. `/api/user/defaults` resolves those slugs from the token, and only
   * `/users/current` carries the AccountManager account id Fullstory is keyed by.
   */
  getIdentity(): Observable<FullstoryIdentity> {
    return this.getDefaults().pipe(
      switchMap(({ accountSlug, brandSlug }) =>
        this.getCurrentUser(accountSlug, brandSlug),
      ),
      map((user) => ({
        amAccountId: user.account.amAccountId,
        brandId: user.brand.id,
      })),
    );
  }

  private getDefaults(): Observable<IUserDefaults> {
    return this.http.get<IUserDefaults>(`${this.baseUrl}/api/user/defaults`);
  }

  private getCurrentUser(
    accountSlug: string,
    brandSlug: string,
  ): Observable<ICurrentUser> {
    return this.http.get<ICurrentUser>(
      `${this.baseUrl}/api/${accountSlug}/${brandSlug}/users/current`,
    );
  }
}
